import { render, staticRenderFns } from "./DataSourceDetailed.vue?vue&type=template&id=2ba2318e&"
import script from "./DataSourceDetailed.vue?vue&type=script&lang=js&"
export * from "./DataSourceDetailed.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceDetailed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports